export default "__VITE_ASSET__UOroKcWr__"